export default [
  {
    path: "/report-margin",
    name: "report-margin",
    meta: {
      title: "Маржинальный отчёт",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-margin/views/index.vue"),
  },
  {
    path: "/report-margin-archive",
    name: "report-margin-archive",
    meta: {
      title: "Маржинальный отчёт (+Архив)",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-margin/views/archive.vue"),
  },
  {
    path: "/report-margin-partner",
    name: "report-margin-partner",
    meta: {
      title: "Партнёрские контракты и взаиморасчёты",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-margin/views/partner.vue"),
  },
  {
    path: "/report-margin-product",
    name: "report-margin-product",
    meta: {
      title: "Продукты",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-margin/views/product.vue"),
  },
  {
    path: "/report-margin/:id",
    name: "report-margin-view",
    meta: {
      title: "Маржинальный отчёт",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-margin/views/view.vue"),
  },
];
